// extracted by mini-css-extract-plugin
export var filterButton = "_sp-1";
export var filtersContainer = "_sp-0";